import React from "react";
import "./BookingStep2.scss";
import { BsChevronRight } from "react-icons/bs";
import { AiOutlineUser } from "react-icons/ai";
// import personellData from "../../../data/personellData.json";

const BookingStep2 = (props) => {
  const personell = props.persons.filter((elem) =>
    elem.services.some((el) => el.id === props.service_id)
  );

  //TEMP - until response is changed
  // const personell = props.persons;

  return (
    <div
      className="BookingStep2"
      ref={props.refr}
      onScroll={props.handleScroll}
    >
      <div
        className="singleWorker"
        onClick={() => {
          props.nextStep(null, null, null);
          document.querySelector(".BookingHeader").className = "BookingHeader";
        }}
      >
        <div className="workerLeft">
          <div className="workerImg">
            <AiOutlineUser />
          </div>
          <div className="workerInfo">
            <h1>Ingen preferens</h1>
            <p>Störst tillgänglighet</p>
          </div>
        </div>
        <div className="workerRight">
          <BsChevronRight />
        </div>
      </div>
      {personell.length > 0 &&
        personell.map((item, index) => (
          <div
            key={index}
            className="singleWorker"
            onClick={() => {
              const name = `${item.first_name} ${item.last_name}`;
              props.nextStep(name, item.calendar.id, item.calendar.toc);
              document.querySelector(".BookingHeader").className =
                "BookingHeader";
            }}
          >
            <div className="workerLeft">
              <div className="workerImg">
                <AiOutlineUser />
              </div>
              <div className="workerInfo">
                <h1>{`${item.first_name} ${item.last_name}`}</h1>
                <p>
                  {item.calendar.title.length > 17
                    ? `${item.calendar.title.substring(0, 17)}...`
                    : item.calendar.title}
                </p>
              </div>
            </div>
            <div className="workerRight">
              <p>★</p>
              <span>4.8</span>
              <BsChevronRight />
            </div>
          </div>
        ))}
    </div>
  );
};

export default BookingStep2;
